import type { GroupRoundEnriched } from '@/lib/db/types';
import { appliesMoney, stakeFromDbRow } from '@/lib/games/engine/stakes-helpers';

export function roundHasMoneyStakes(round: GroupRoundEnriched): boolean {
  return (round.games || []).some((g) => {
    if (!g.enabled) return false;
    const config = stakeFromDbRow(g.format_id, (g.stakes || {}) as Record<string, unknown>);
    return appliesMoney(config);
  });
}

export function isRoundParticipant(round: GroupRoundEnriched, memberId: string): boolean {
  return (round.players || []).some((p) => p.member_id === memberId);
}
